import {
    Component,
    Input,
    forwardRef,
    ChangeDetectionStrategy,
} from '@angular/core';
import {
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
    UntypedFormControl,
} from '@angular/forms';
import { Item } from '@masar/common/models';
import { functions } from '../../../common/misc/functions';

@Component({
    selector: 'app-department-list-field',
    templateUrl: './department-list-field.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DepartmentListFieldComponent),
            multi: true,
        },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class DepartmentListFieldComponent implements ControlValueAccessor {
    @Input() public departments: Item[] = [];
    @Input() public placeholder: string;
    @Input() public multiple: boolean = true;
    @Input() public formControl: UntypedFormControl;
    @Input() public label: string = 'translate_owning_department';
    @Input() public showLabel: boolean = false;
    @Input() public showValidationError: boolean = true;
    @Input() public triedToSubmit: boolean = false;

    public value: any;

    public writeValue(value: any): void {
        this.value = value;
    }

    public registerOnChange(fn: (value: any) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    public compareWith(a: { id?: string }, b: { id?: string }): boolean {
        return a?.id === b?.id;
    }

    public onSelectionChange(value: any): void {
        this.value = value;
        this.onChange(value);
        this.onTouched();
    }

    public isRequired(): boolean {
        if (!this.formControl) {
            return false;
        }
        return functions.hasRequiredField(this.formControl);
    }

    public shouldShowValidationError(): boolean {
        if (!this.formControl || !this.showValidationError) {
            return false;
        }
        return (
            this.triedToSubmit &&
            this.formControl.invalid &&
            this.formControl.errors?.['required']
        );
    }

    private onChange: (value: any) => void = () => {
        // This function is replaced by registerOnChange
    };
    private onTouched: () => void = () => {
        // This function is replaced by registerOnTouched
    };
}
